var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message-template',{attrs:{"icon":"/illustration-sleepy-basket.svg","text":"No orders yet","additional-text":"Here you will find your accepted orders."}})
}
var staticRenderFns = []

export { render, staticRenderFns }